import React from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Paginator} from "primereact/paginator";
import {webInfo} from "../../../utils/webInfo";
import {Button} from "primereact/button";
import {Link} from "react-router-dom";
import {catchError} from "../../../utils/helper";
import {Skeleton} from "primereact/skeleton";
import {InputSwitch} from "primereact/inputswitch";
import usePost from "../../../hooks/usePost";


const CropTable = ({products,total,selectedDepot,onPageChange,page,perPage,update,setUpdate}:any) => {
    const {post, loading: ploading} = usePost()
    const actionTemplate = (rowData: any) => (
        <div className="flex gap-2 justify-content-center">
            <Button
                icon="pi pi-pencil"
                label="Edit"
                className="p-button-sm"
                onClick={() => console.log("Details:", rowData)}
            />
            <Button
                icon="pi pi-trash"
                label="Remove"
                disabled
                className="p-button-sm p-button-danger"
                onClick={() => console.log("Remove:", rowData.id)}
            />
        </div>
    );
    const imageTemplate = (rowData:any) => (
        <img
            src={`${webInfo.baseUrl}/${rowData.image}`}
            alt={rowData.name}
            style={{ width: "20px", borderRadius: "6px" }}
        />
    );

    const divisionBodyTemplate = ()=>(
        <span>{selectedDepot.name}</span>
    )

    const categoryTemplate = (rowData:any)=>{
        const link = `/products-crop-care?category_code=${rowData.id}`;
        return <Link className="text-gray-900 underline" style={{ cursor: "pointer" }} to={link}>
            {rowData?.name}
        </Link>
    }
    const publishStatus = (rowData: any) => {
        const statusUpdateUrl = `${webInfo.baseUrl}/api/admin/products-crop-category/${rowData?.id}/publish-status`
        const updateStatus = async (rowData: any) => {
            const payload = {
                status: Number(rowData.status) === 1 ? 0 : 1,
            }
            try {
                const res: any = await post(statusUpdateUrl, true, payload)
                if (res.success) {
                    setUpdate(!update);
                }
            } catch (e) {
                catchError(e)
            }
        }

        if (ploading) {
            return <Skeleton width={"4rem"} height={"2.5rem"}></Skeleton>
        }
        return <div className="flex gap-2 justify-content-start">
            <InputSwitch checked={Number(rowData?.status) === 1} onChange={() => updateStatus(rowData)}/>
        </div>
    }
    return (
        <div>
            <DataTable
                value={products}
                rows={5}
                stripedRows
            >
                <Column
                    header="Image"
                    body={imageTemplate}
                    style={{ width: "100px", textAlign: "center" }}
                />
                <Column body={categoryTemplate} header="Category Name" sortable />
                <Column body={divisionBodyTemplate} header="Division" sortable />
                <Column
                    header="Status"
                    body={publishStatus}
                    style={{ width: "120px", textAlign: "center" }}
                />
                <Column
                    header="Actions"
                    body={actionTemplate}
                    style={{ width: "120px", textAlign: "center" }}
                />
            </DataTable>
            <Paginator
                first={(page - 1) * perPage}
                rows={perPage}
                totalRecords={total}
                rowsPerPageOptions={[10, 20, 30]}
                onPageChange={onPageChange}
            />
        </div>
    );
};

export default CropTable;